import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

import { FETCH_FAVORITE_PROFESSIONALS, fetchFavoriteProfessionals } from '../actions';
import BackButton from '../commonComponents/BackButton';
import FavoriteCard from './favoriteProfessionals/FavoriteCard';
import '../themes/global.scss';
import EmptyFavoriteImage from '../images/EmptyFavorite.png';
import { Colors } from '../themes/colors';
import { createLoadingSelector } from '../api/selectors';
import CustomSpinner from '../commonComponents/CustomSpinner';

export default () => {
  const dispatch = useDispatch();
  const loadingSelector = createLoadingSelector([FETCH_FAVORITE_PROFESSIONALS]);

  const isLoading = useSelector((state) => loadingSelector(state));
  const favoriteProfessionals = useSelector((state) => state.user.favoriteProfessionals);

  useEffect(() => {
    dispatch(fetchFavoriteProfessionals());
  }, [dispatch]);

  const renderContent = () => {
    if (isLoading) {
      return <CustomSpinner isLoading={isLoading} />;
    } if (favoriteProfessionals.length === 0) {
      return (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            maxWidth: '827px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <img
            src={EmptyFavoriteImage}
            alt="Computer"
            style={{
              width: '320px',
              height: '285px',
              alignSelf: 'center',
              margin: '35px 0',
            }}
          />
          <p className="global_font f-dark">It looks like you have not added any Favorite professionals yet! When you “Favorite” a professional, you will be able to send open shifts directly to the listed professionals. </p>
          <p
            className="global_font f-18"
            style={{
              color: Colors.primary_500, fontWeight: 700, margin: '20px 0',
            }}
          >
            How to add a professional to your Favorites List:
          </p>
          <ul style={{ paddingLeft: '15px' }}>
            <li style={{ fontSize: '15px', fontWeight: 'bold' }} className="f-dark global_font">
              Job Summary page: Click “Add to Favorites” when prompted to leave a review for a professional..
            </li>
            <li style={{ fontSize: '15px', fontWeight: 'bold', marginTop: '30px' }} className="f-dark global_font">
              {'Past Shifts page: Go to Schedule > Past Shifts, and view the Shift Details page. On this page, you will find an “Add to Favorites” button. Click this button and Confirm.'}
            </li>
          </ul>
        </motion.div>
      );
    } if (favoriteProfessionals.length > 0) {
      return (
        <div style={{ maxWidth: '827px' }}>
          <p className="global_font f-dark">This page contains a list of your favorite professionals. You can directly request your Favorites by visiting the Shift Details page for open shifts.</p>
          <motion.div className="favorite-card-container" layout>
            <AnimatePresence>
              {favoriteProfessionals?.map((professional) => (
                <FavoriteCard
                  key={professional.id}
                  name={professional.fullname}
                  profession={professional.professions[0]}
                  level={professional.activityLevel}
                  imageSrc={professional.profileImage}
                  id={professional.id}
                  isAvailable={professional.isAvailable}
                />
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      );
    }
  };
  return (
    <div className="component_container">
      <div className="floating_container" style={{ flexDirection: 'column', paddingBottom: '100px' }}>
        <div style={{ marginTop: 20, marginLeft: 30 }}>
          <BackButton />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <h1
            className="card-title global_font f-dark"
            style={{
              textAlign: 'center',
            }}
          >
            Favorites List
          </h1>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};
